import React, { useState, useEffect } from "react";
import { ReGeoMapChart } from "regeo-map-chart";
import { Modal, Button, Accordion } from "react-bootstrap";
import "./Modal.css";
import { countries,  countries_continents, regions, continents} from "../../Data/Countries";
import Section from "../../Models/Section";
import HTMLEditorComponent from "./HTMLEditorComponent";
import HTMLEditorModal from "./HTMLEditorModal";
import HTMLReader from "./HTMLReader";
import { urlSchemeToFunctions } from "../../CommonWeb/Common";
import InnerHTML from "dangerously-set-html-content";

const GeoCharts = (props) => {
  // const [placesToVisit, SetplacesToVisit] = useState([]);
  // const [SectionHTML, SetSectionHTML] = useState("");
  const [HTMLEditorModalShow, SetHTMLEditorModalShow] = useState(false);
  const [HTMLEditorModalContent, SetHTMLEditorModalContent] = useState(false);
  const [HTMLContent, setHTMLContent] = useState("");
  const [HTMLReaderModal, setHTMLReaderModal] = useState(false);
  const [regionSelected, setregionSelected] = useState("");
  const [citiesVisited, setcitiesVisited] = useState("");
  const [continentSelected, setContinentSelected] = useState("");
  

  let onHide = props.onHide;
  let stats = props.data;
  
  let visited_continents = [];
  let visited_countries = [];
  let visited_cities = [];
  let data = [ ["Region", "Cities"]];
  let countries_per = 0;
  let continents_per = 0;
  let not_visited_continents = [];
  let not_visited_countries = [];
  let places_to_visit = [];
  let section = new Section();

// useEffect(() => {
  for(let i = 0; i < stats.length; i++)
  { 
    let found = false
    for(let k = 0; k < data.length; k++){
      if(data[k][0] === stats[i].Region){
        found=true;
        data[k][1] +=1;
        break;
      }
    }
    if(!found){
      data.push([stats[i].Region, 1]);
    }

    const places = window.guide_obj.places.placesList;
    places_to_visit = [];
    for(let i = 0; i < places.length; i++){
      const groups = places[i].Group; 
      if(groups === null || typeof groups === "undefined") continue;
      let found = false;
      for(let g = 0; g < groups.length; g++){
        let group = window.guide_obj.getGroupByID(groups[g], "guide")
        if(group === null) continue;
        if(group.name === "Bucket List_m") {
          found = true;
          break;
        }
      }
      if(found === false) continue;
      //if(places[i].Visited === false) 
      places_to_visit.push(places[i]);
    }
    // SetplacesToVisit(places_to_visit);
  
    // SetSectionHTML(section.html);
    // SetSection(section);
  }

  for(let i = 0; i < stats.length; i++){
    if(!visited_continents.includes(stats[i].Continent)) visited_continents.push(stats[i].Continent)
    if(!visited_countries.includes(stats[i].Country)) visited_countries.push(stats[i].Country)
    if(!visited_cities.includes(stats[i].City)) visited_cities.push(stats[i].City)
  }
  countries_per = ((visited_countries.length/countries.length)*100).toFixed(2);
  continents_per = ((visited_continents.length/7)*100).toFixed(2);
  not_visited_continents = [];
  not_visited_countries = [];
  for(let i = 0; i < countries.length; i++)
    if(!visited_countries.includes(countries[i]))
      not_visited_countries.push(countries[i])
  
  for(let i = 0; i < continents.length; i++)
    if(!visited_continents.includes(continents[i]))
      not_visited_continents.push(continents[i])
  visited_continents.sort();
  visited_countries.sort();
  visited_cities.sort();
  not_visited_continents.sort();
  not_visited_countries.sort();

  const _visited_continents = visited_continents.join(", ")
  const _not_visited_continents = not_visited_continents.join(", ")

  let placesToVisit = places_to_visit;

  const closeModal = () => {
    onHide();
  };

 function regionClicked (region) {
    //console.log("Region", region);
    //alert('You clicked on: ' + region);
    let _region = "Unknown";
    let _continent = "Unknown";
    let citiesVisited = 0;
    for(let i = 0; i<countries_continents.length; i++){
      if(countries_continents[i].region.toUpperCase() === region.toUpperCase()){
        _region = countries_continents[i].country;
        _continent = countries_continents[i].continent;
        break;
      }
    }
    let stats = data;
    for(let i = 0; i<stats.length; i++){
      if(stats[i][0].toUpperCase() === region.toUpperCase()){
        citiesVisited = stats[i][1];
     }
    }
    setregionSelected(_region);
    setcitiesVisited(citiesVisited);
    setContinentSelected(_continent);
    //this.regionsToDisplay();
  }

  window.regionClicked = regionClicked;

  const GeoChartHTML = () => {
    const html_doc = `<html>
  <head>
    <script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>
    <script type="text/javascript">
    setTimeout(function() {
      google.charts.load('current', {
        'packages':['geochart'],
      });
      google.charts.setOnLoadCallback(drawRegionsMap);
    }, 300);
   
// 		async function waitForCondition(condition, maxWaitTime) {
//   const startTime = Date.now();

//   while (Date.now() - startTime < maxWaitTime) {
//     if (condition()) {
//       return true;
//     }
//     await new Promise(resolve => setTimeout(resolve, 100)); // Check every 100ms
//   }
//   return false; // Timed out
// }

// // Example usage:
// let operationCompleted = false;

// // // Simulate an asynchronous operation
// // setTimeout(() => {
// //   operationCompleted = true;
// // }, 2000);

// async function runExample() {
//   const maxWait = 3000; // Maximum wait time in milliseconds

//   const success = await waitForCondition(() => (typeof google !== "undefined"), maxWait);

//   if (success) {
//     console.log("Operation completed within the time limit.");
//       google.charts.load('current', {
//         'packages':['geochart'],
//       });
//       google.charts.setOnLoadCallback(drawRegionsMap);
//     window.regionClicked(region);
// 	 });
	
//     chart.draw(data, options);
//   } else {
//     console.log("Operation timed out");
//   }
// }

// runExample();
      function drawRegionsMap() {
        var data = google.visualization.arrayToDataTable(${regionsToDisplay()});

        var options = {colorAxis: {colors: ['#90D5FF', '#3C3CE8']}, legend: 'none', };
		
        var chart = new google.visualization.GeoChart(document.getElementById('regions_div'));

	 google.visualization.events.addListener(chart, 'regionClick', function(eventData) {
		var region = eventData.region;
		//alert('You clicked on: ' + region);
    window.regionClicked(region);
	 });
	
        chart.draw(data, options);
      }
    </script>
  </head>
  <body>
    <div id="regions_div" class="map" style="width: 100%; height: 250px;"></div>
  </body>
</html>`;
//console.log(html_doc)
    return html_doc;
  }


  const regionsToDisplay = () => {
    let stats = props.data;
    console.log(stats);
    let data = [];
    for(let i = 0; i < stats.length; i++)
    { 
      let found = false
      for(let k = 0; k < data.length; k++){
        if(data[k][0].v.toUpperCase() === stats[i].Region.toUpperCase()){
          found=true;
          data[k][1] +=1;
          break;
        }
      }
      if(!found){
        data.push([{
          v: stats[i].Region.toUpperCase(),
          f: stats[i].Country}, 1]);
      }
    }
    const withHeader = [['Regions', 'Cities']].concat(data)
    //console.log(JSON.stringify(withHeader))
    return(JSON.stringify(withHeader))
  }
    // if (HTMLEditorModalShow)
    //   return (
    //     <HTMLEditorModal
    //       show={HTMLEditorModalShow}
    //       onHide={() => SetHTMLEditorModalShow(false)}
    //       html={HTMLEditorModalContent}
    //       callback={editCallback}
    //       callback_rt={null}
    //     />
    //   );

    // if (HTMLReaderModal)
    //   return(<HTMLReader html={HTMLContent} show={HTMLReaderModal} title={"Bucket List Notes"} onHide={() => setHTMLReaderModal(false)} />)
  return (
    <div className="modal">
      <Modal
        {...props}
        animation={false}
        dialogClassName="myModalClass"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
        scrollable
        // style={{ padding: "50px" }}
        onHide={() => closeModal()}
      >
          <Modal.Header closeButton>
            <div style={{ width: "100%" }}>
              <div className="sort">
                <div className="dialog-heading">
                  <div>
                    <h4 className="color-blue">Bucket List</h4>
                  </div>
                </div>
              </div>    
              
            </div>
          </Modal.Header>
        <Modal.Body>
        <div>
        {/* <ReGeoMapChart data={data} width={350}
          
          hideMapLegend={true}
        /> */}
        <InnerHTML
            className="home-resize-panel"
            id="home-content"
            // style={{ fontSize: `${ContentFontZoom}%` }}
            html={GeoChartHTML()}
          />
            
        </div>
            {regionSelected !== "" ? <div><span className="color-black">{`Continent: ${continentSelected} `}</span></div> : null}
            {regionSelected !== "" ? <span className="color-black">{`Region: ${regionSelected}, `}</span> : null}
            {regionSelected !== "" ? <span className="color-black">{`Cities: ${citiesVisited}`}</span> : null}
          <div>
          
          <span className="color-black">{`Continents: ${visited_continents.length}/7 = ${continents_per}%`}</span>
          <br></br>
          <span className="color-black">{`Countries/regions: ${visited_countries.length}/${countries.length} = ${countries_per}%`}</span>
          <br></br>
          <span className="color-black">{`Cities: ${visited_cities.length}`}</span>
          
          
          <span className="color-black">{"Make sure that Places include country, city and Visited=true or false"}</span>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Continents Visited</Accordion.Header>
              <Accordion.Body>
                {/* <h0 className="color-blue">Continents Visited</h0> */}
                <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
                  <ol type="1">
                  <span className="color-black">{`${_visited_continents}`}</span>
                  
                    {/* {visited_continents.map((item, index) => (
                      <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                        {item}
                      </li>
                    ))} */}
                  </ol>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Countries/Regions Visited</Accordion.Header>
              <Accordion.Body>
          {/* <h0 className="color-blue">Countries/Regions Visited</h0> */}
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
            <ol type="1">
              {visited_countries.map((item, index) => (
                <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {item}
                </li>
              ))}
            </ol>
          </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Cities Visited</Accordion.Header>
              <Accordion.Body>
          {/* </div><h0 className="color-blue">Cities Visited</h0> */}
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
            <ol type="1">
              {visited_cities.map((item, index) => (
                <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {item}
                </li>
              ))}
            </ol>
          </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Continents Not Visited</Accordion.Header>
              <Accordion.Body>
        {/* <h0 className="color-blue">Continents Not Visited</h0> */}
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
            <ol type="1">
              <span className="color-black">{`${_not_visited_continents}`}</span>
              {/* {not_visited_continents.map((item, index) => (
                <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {item}
                </li>
              ))} */}
            </ol>
          </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Countries/Regions Not Visited</Accordion.Header>
              <Accordion.Body>
          {/* <h0 className="color-blue">Countries/Regions Not Visited</h0> */}
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
            <ol type="1">
              {not_visited_countries.map((item, index) => (
                <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {item}
                </li>
              ))}
            </ol>
            </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Bucket List</Accordion.Header>
              <Accordion.Body>
          {/* <h0 className="color-blue">Bucket List (Places not yet visited)</h0> */}
          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
            <ol type="1">
              {placesToVisit.map((item, index) => (
                <li key={index} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {item.Name}
                </li>
              ))}
            </ol>
          </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
                {/* <div className="text-center">
                    <Button className="mt-3" onClick={() => ShowNotes()}>
                      View Notes
                    </Button>
              </div>
        
                <div className="text-center">
                    <Button className="mt-3" onClick={() => EditNotes()}>
                      Edit Notes
                    </Button>
            </div> */}
          {/* <HTMLEditorComponent
                show={true}
                onHide={() => null}
                html={SectionHTML}
                callback={null}
                callback_rt={editInfoCallback}
                embedded={true}
                title={"Notes"}
              /> */}
          </div>
          
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default GeoCharts;
